module.exports = __webpack_public_path__ + "img/MaskGroup 2906.fffa38a6.svg";